/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

/**
 * Get tenant from hash of URL path.
 * @param {string} hash Hash string from path.
 * @returns {string} Tenant from hash string.
 */
export function getTenantFromPath(hash) {
  const matches = hash.match(/\/@([^/]*)\//);
  return matches && matches[1];
}

/**
 * Get name of org.
 * @param {string} org String with org.
 * @param {Array} map List of orgs.
 * @returns {string} Org name or unknown.
 */
export function getOrgName(org, map) {
  let [ident, authSrc] = org.split('@');
  let s = map.find(e => e.orgRef.ident === ident && e.orgRef.authSrc === authSrc);
  return s ? s.orgName : 'unknown';
}
